import { render, staticRenderFns } from "./QuestionsIframe.vue?vue&type=template&id=1bf5a748&"
import script from "./QuestionsIframe.vue?vue&type=script&lang=ts&"
export * from "./QuestionsIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports